export default class NewsList {
    static exec() {
        const els = document.querySelectorAll('[data-component="news-list"]');
        els.forEach(function (el) {
            new NewsList(el);
        });
    }

    el;
    state = false;

    constructor(element) {
        const self = this;
        this.el = element;

        const tab_el = this.el.querySelectorAll(['[data-el="tab"]'])
        if (tab_el) {
            tab_el.forEach(function (el) {
                el.addEventListener('click', function () {
                    if (el.dataset.state == 'close') {
                        self.el.querySelectorAll(['[data-state="open"]']).forEach(function (el) {
                            el.dataset.state = 'close';
                        });
                        self.el.querySelectorAll(['[data-year="' + el.dataset.year + '"]']).forEach(function (el) {
                            el.dataset.state = 'open';
                        });
                    } else {
                        el.dataset.state = 'close';
                    }
                });
            });
        }

        const tab_select_el = this.el.querySelectorAll(['[data-el="tab-select"]'])
        if (tab_select_el) {
            tab_select_el.forEach(function(el) {
                el.addEventListener('change', function(e) {
                    const year = e.target.value;
                    const index = e.target.selectedIndex;
                    const option = e.target.options[index];
                    const href = option.dataset.href;
                    if (year) {
                        self.el.querySelectorAll(['[data-state="open"]']).forEach(function(el) {
                            el.dataset.state = 'close';
                        });
                        self.el.querySelectorAll(['[data-year="' + year + '"]']).forEach(function(el) {
                            el.dataset.state = 'open';
                        });
                    }
                    console.log(href);
                    if (href) {
                        document.location.href = href;
                    }
                });
            });
        }
    }
}